var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "ak-upload",
        _vm._g(
          _vm._b(
            {
              scopedSlots: _vm._u([
                {
                  key: "files",
                  fn: function (ref) {
                    var files = ref.files
                    var outputFiles = ref.outputFiles
                    var showImagePreview = ref.showImagePreview
                    var downloadPath = ref.downloadPath
                    var remove = ref.remove
                    return [
                      _vm.currentValue.length
                        ? _c(
                            "draggable",
                            {
                              staticClass: "cms-media-control__files",
                              attrs: { tag: "div" },
                              model: {
                                value: _vm.currentValue,
                                callback: function ($$v) {
                                  _vm.currentValue = $$v
                                },
                                expression: "currentValue",
                              },
                            },
                            _vm._l(_vm.currentValue, function (object) {
                              return _c(
                                "div",
                                {
                                  key: object.id,
                                  staticClass: "cms-media-control__file",
                                },
                                [
                                  _vm.isFileObject(object)
                                    ? _c("cms-media-card", {
                                        attrs: {
                                          clickable: false,
                                          body: object.originalFilename,
                                          img:
                                            showImagePreview(object) &&
                                            object.downloadPath
                                              ? downloadPath(object)
                                              : null,
                                          downloadPath:
                                            showImagePreview(object) &&
                                            object.downloadPath
                                              ? downloadPath(object)
                                              : null,
                                          recommendedFileSize:
                                            _vm.recommendedFileSize,
                                          fileSize: object.fileSize,
                                          size: "small",
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "top",
                                              fn: function (ref) {
                                                var img = ref.img
                                                return [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "cms-media-control__preview",
                                                    },
                                                    [
                                                      !showImagePreview(
                                                        object
                                                      ) && object.description
                                                        ? _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "ak-upload__preview-image d-flex align-items-end justify-content-center",
                                                            },
                                                            [
                                                              _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "ak-upload__preview-name",
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "\n                                            " +
                                                                      _vm._s(
                                                                        object.description
                                                                      ) +
                                                                      "\n                                        "
                                                                  ),
                                                                ]
                                                              ),
                                                            ]
                                                          )
                                                        : _vm._e(),
                                                      _vm._v(" "),
                                                      showImagePreview(
                                                        object
                                                      ) && object.downloadPath
                                                        ? _c("img", {
                                                            attrs: { src: img },
                                                          })
                                                        : _vm._e(),
                                                      _vm._v(" "),
                                                      _c(
                                                        "a",
                                                        {
                                                          staticClass:
                                                            "ak-upload__preview-download",
                                                          attrs: {
                                                            href: downloadPath(
                                                              object
                                                            ),
                                                          },
                                                        },
                                                        [
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "ak-upload__preview-download-label",
                                                            },
                                                            [
                                                              _c(
                                                                "span",
                                                                {
                                                                  staticClass:
                                                                    "ak-icon",
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "download"
                                                                  ),
                                                                ]
                                                              ),
                                                              _vm._v(
                                                                "\n                                            Download\n                                        "
                                                              ),
                                                            ]
                                                          ),
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "a",
                                                        {
                                                          staticClass:
                                                            "ak-upload__file-remove",
                                                          on: {
                                                            click: function (
                                                              $event
                                                            ) {
                                                              return remove(
                                                                object
                                                              )
                                                            },
                                                          },
                                                        },
                                                        [
                                                          _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "ak-icon",
                                                            },
                                                            [_vm._v("close")]
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              },
                                            },
                                          ],
                                          null,
                                          true
                                        ),
                                      })
                                    : _vm._e(),
                                  _vm._v(" "),
                                  object.widget
                                    ? _c("ak-widget", {
                                        attrs: {
                                          type: object.widget.type,
                                          attributes: Object.assign(
                                            {},
                                            object.widget.attributes,
                                            {
                                              id: object.widget.id,
                                              baseRelationString: _vm.id,
                                              recommendedFileSize:
                                                _vm.recommendedFileSize,
                                            }
                                          ),
                                          slots: object.widget.slot,
                                          objectId: object.id,
                                          contextType: "grid-cell",
                                          callbackUri:
                                            "/" +
                                            _vm.currentRelation.foreignList
                                              .bundle +
                                            "/" +
                                            _vm.currentRelation.foreignList.id +
                                            "/",
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "contextual-widgets",
                                              fn: function (ref) {
                                                var slotListeners =
                                                  ref.slotListeners
                                                return [
                                                  _c(
                                                    "ak-popover-menu",
                                                    {
                                                      attrs: {
                                                        direction: "right",
                                                      },
                                                      scopedSlots: _vm._u(
                                                        [
                                                          {
                                                            key: "trigger",
                                                            fn: function (ref) {
                                                              var open =
                                                                ref.open
                                                              var toggleMenu =
                                                                ref.toggleMenu
                                                              return [
                                                                _c(
                                                                  "ak-button",
                                                                  {
                                                                    staticClass:
                                                                      "ak-table__contextual-trigger",
                                                                    attrs: {
                                                                      size: "x-small",
                                                                      active:
                                                                        open,
                                                                      disableBackground: true,
                                                                      colorMode:
                                                                        "text-bg",
                                                                    },
                                                                    on: {
                                                                      click:
                                                                        toggleMenu,
                                                                    },
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "i",
                                                                      {
                                                                        staticClass:
                                                                          "ak-icon ak-icon--large ak-icon--bolt",
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          "\n                                                more_horiz\n                                            "
                                                                        ),
                                                                      ]
                                                                    ),
                                                                  ]
                                                                ),
                                                              ]
                                                            },
                                                          },
                                                        ],
                                                        null,
                                                        true
                                                      ),
                                                    },
                                                    [
                                                      _vm._v(" "),
                                                      _c(
                                                        "ak-popover-menu-item",
                                                        {
                                                          attrs: {
                                                            title:
                                                              _vm.$t(
                                                                "Wijzigen"
                                                              ),
                                                            icon: "edit",
                                                          },
                                                          on: {
                                                            click: function (
                                                              $event
                                                            ) {
                                                              return _vm.edit(
                                                                object
                                                              )
                                                            },
                                                          },
                                                        }
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "a",
                                                    {
                                                      staticClass:
                                                        "ak-upload__file-remove ak-upload__file-remove--left",
                                                      attrs: { href: "#" },
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          $event.preventDefault()
                                                          return _vm.deleteSelected(
                                                            object.id
                                                          )
                                                        },
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "ak-icon",
                                                        },
                                                        [_vm._v("close")]
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              },
                                            },
                                          ],
                                          null,
                                          true
                                        ),
                                      })
                                    : _vm._e(),
                                ],
                                1
                              )
                            }),
                            0
                          )
                        : _vm._e(),
                    ]
                  },
                },
                {
                  key: "button",
                  fn: function () {
                    return [
                      _c(
                        "div",
                        { staticClass: "cms-media-control__buttons" },
                        [
                          _vm.enableUpload
                            ? [
                                _c(
                                  "a",
                                  {
                                    staticClass:
                                      "ak-button ak-button--small ak-button--ghost ak-upload__button cms-media-control__button",
                                    attrs: { href: "#" },
                                  },
                                  [
                                    _vm._v(
                                      "\n                            " +
                                        _vm._s(_vm.$t("Kies van computer")) +
                                        "\n                        "
                                    ),
                                  ]
                                ),
                                _vm._v(
                                  "\n                        " +
                                    _vm._s(_vm.$t("of")) +
                                    "\n                    "
                                ),
                              ]
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "router-link",
                            {
                              staticClass:
                                "ak-button ak-button--small ak-button--outlined cms-media-control__button",
                              attrs: { to: _vm.mediaLibraryRoute },
                            },
                            [
                              _vm._v(
                                "\n                        " +
                                  _vm._s(_vm.$t("Kies uit media bibliotheek")) +
                                  "\n                    "
                              ),
                            ]
                          ),
                        ],
                        2
                      ),
                    ]
                  },
                  proxy: true,
                },
              ]),
              model: {
                value: _vm.imageValue,
                callback: function ($$v) {
                  _vm.imageValue = $$v
                },
                expression: "imageValue",
              },
            },
            "ak-upload",
            _vm.$props,
            false
          ),
          _vm.$listeners
        )
      ),
      _vm._v(" "),
      _vm.renderRelationResolver
        ? _c("cms-media-relation-resolver", {
            attrs: {
              relationString: _vm.currentRelationString,
              relationReference: _vm.bundleId + "," + _vm.definitionId,
              defaultIdsSelected: _vm.selectedIds,
              enableForeignList: _vm.enableForeignList,
            },
            on: {
              close: _vm.triggerClose,
              updateRelations: _vm.updateRelations,
              refresh: _vm.updateRelations,
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }